import { useEffect, useState } from "react";
import {
  APP_ROUTES,
  LEGAL_ROUTES,
  getAppRouteFromPathname,
  isAuthRoute,
} from "./appRoutes";
import { replaceBrowserRoute } from "./browserRoute";

const getCurrentRoute = () => {
  if (typeof window === "undefined") return APP_ROUTES.ROOT;
  return getAppRouteFromPathname(window.location.pathname);
};

export default function useAppRoute({
  authLoading,
  user,
  passwordRecoveryActive,
}) {
  const [currentRoute, setCurrentRoute] = useState(getCurrentRoute);

  useEffect(() => {
    const handlePopState = () => {
      setCurrentRoute(getCurrentRoute());
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  useEffect(() => {
    if (authLoading) return;
    if (LEGAL_ROUTES.includes(currentRoute)) {
      return;
    }

    const targetRoute = (() => {
      if (passwordRecoveryActive) return APP_ROUTES.LOGIN;
      if (user) return APP_ROUTES.HOME;
      if (currentRoute === APP_ROUTES.ROOT || isAuthRoute(currentRoute)) {
        return currentRoute;
      }
      return APP_ROUTES.LOGIN;
    })();

    if (currentRoute === targetRoute) return;

    replaceBrowserRoute(targetRoute);
    setCurrentRoute(targetRoute);
  }, [authLoading, currentRoute, passwordRecoveryActive, user]);

  return currentRoute;
}
